import React from 'react';
import './PC.css';
import Goncharov from '../../img/PC/Goncharov.png'
import Hemanth from '../../img/PC/Hemanth.png'
import Shah from '../../img/PC/Shah.png'
import Meta from '../../img/PC/Meta.png'
import paypal from '../../img/PC/paypal.png'
import pedalsup from '../../img/PC/pedalsup.png'
import Villa from '../../img/PC/Villa.png'
import NodeSource from '../../img/PC/NodeSource.png'
import Jonas from '../../img/PC/Jonas.png'
import Nrwlio from '../../img/PC/Nrwlio.png'
import Shavin from '../../img/PC/Shavin.png'
import Mejia from '../../img/PC/Mejia.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pc: [
        {
          photo: Goncharov,
          name: 'Andrey Goncharov',
          position: 'Software Engineer',
          ln: 'https://www.linkedin.com/in/aigoncharov/',
          tw: 'https://twitter.com/ai_goncharov',
          github: 'https://github.com/aigoncharov',
          website: 'https://goncharov.page/',
          logo: Meta,
        },
        {
          photo: Hemanth,
          name: 'Hemanth HM',
          position: 'Engineering Manager',
          website: 'https://h3manth.com',
          logo: paypal,
        },
        {
          photo: Shah,
          name: 'Harsh Shah',
          position: 'CTO',
          ln: 'https:///linkedin.com/in/harshcrop',
          tw: 'https://twitter.com/harshcrop',
          github: 'https://github.com/harshcrop',
          logo: pedalsup,
        },
        {
          photo: Villa,
          name: 'Marian Villa',
          position: 'Sr Fullstack Product Designer',
          ln: 'https://www.linkedin.com/in/Marianvilla',
          tw: 'https://twitter.com/Marianvilla',
          github: 'https://github.com/marianvilla',
          logo: NodeSource,
        },
        {
          photo: Jonas,
          name: 'Miroslav Jonas',
          position: 'Senior software engineer',
          ln: 'https://www.linkedin.com/in/meeroslav',
          tw: 'https://twitter.com/meeroslav',
          github: 'https://github.com/meeroslav',
          logo: Nrwlio,
        },
        {
          photo: Shavin,
          name: 'Maya Shavin',
          position: 'Senior Software Engineer at Microsoft',
          ln: 'https://www.linkedin.com/in/mayashavin',
          tw: 'https://twitter.com/MayaShavin',
          github: 'https://github.com/mayashavin',
        },
        {
          photo: Mejia,
          name: 'Manuel Mejia',
          position: 'Tech Lead at BuildingLink',
          tw: 'https://twitter.com/mejiamanuel57',
        },
      ]
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className="pc_img_block">
          <img className="team_img" src={item.photo} alt={item.name} />
        </div>
        <div className="pc_info">
          <p className="pc_name">{item.name}</p>
          <p className="pc_position">{item.position}</p>
          <div className="pc_links">
            {item.fb && <a className="pc_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="pc_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="pc_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="pc_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="pc_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="pc_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
          </div>
          <img className="pc_logo" src={item.logo} alt="" />
        </div>
      </div>
    )
  }

  render() {
      return (
          <div className="pc container" id='pc'>
              <h3>Program committee</h3>
              <div className='pc_wrap'>
                  <div className="pc_block">
                    {this.state.pc.map((item, i) => this.renderPC(item, i))}
                  </div>
              </div>
          </div>
      )
  }
}